// src/services/ai/providers/ClaudeProvider.js
import AIProvider from './AIProvider';

export default class ClaudeProvider extends AIProvider {
  getName() {
    return 'claude';
  }

  async chat(messages, tools = []) {
    // Claude API stub - would require server-side proxy for API key security
    // In production, use CloudFunctionProvider instead
    throw new Error(
      'Direct Claude API calls are not supported from the client. ' +
      'Use CloudFunctionProvider with provider="claude" for server-side calls.'
    );
  }
}
